import FormattedAddress from "components/Atoms/FormattedAddress";
import React from "react";
import { Message } from "components/Atoms/Message";

interface Props {
  customer: server.dto.BusinessCentralCustomer
}

const BusinessCentralCustomer = (props: Props) => {
  if (props.customer == null) return <Message type="error">{RESX.BusinessCentral.CouldNotFindItemInBusinessCentral}</Message>;

  return <div className="flex-column gap-small">
    <div>
      <h3>{props.customer.name}</h3>
    </div>

    <div>
      <FormattedAddress address={props.customer.address} />
    </div>

    {props.customer.vatNumber && <div>{props.customer.vatNumber}</div>}
  </div>;
};

export default BusinessCentralCustomer;